import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import "./ProductCard.scss";
import CardItemContext from "../../../../context/CardItem/CardItemContext.jsx";
import GiftCode from "./GiftCode";
import { WaveLoading } from "react-loadingg";
// قسمت فوتر سبد خرید که شامل قیمت ها و دکمه نهایی و پرداخت میباشد
const Footer = () => {
  const {
    basketData,
    setActiveStep,
    activeStep,
    itemCount,
    giftCode,
    btnLoading,
  } = useContext(CardItemContext);
  const [totalPrice, setTotalPrice] = useState(0);
  const calculateTotalPrice = () => {
    const price = basketData?.list?.reduce((acc, product) => {
      const productTotal = product.price * product.number;
      return acc + productTotal;
    }, 0);
    setTotalPrice(price);
  };
  useEffect(() => {
    calculateTotalPrice();
  }, [basketData]);

  return (
    <div
      className="footer mt-auto pd-x-20 pd-b-16"
      style={{
        position: "sticky",
        bottom: "0",
        width: "100%",
        backgroundColor: "#EEF1FF",
      }}
    >
      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-end mr-x-6 pd-y-6">
        <GiftCode />
      </div>

      <hr className="mr-t-6" />
      <div
        className="d-flex flex-column flex-sm-row justify-content-between align-items-end"
        style={{ fontSize: "14px", marginTop: "auto" }}
      >
        <div className="d-flex flex-column col-9 col-sm-7 align-self-center">
          {activeStep == 2 && (
            <div className="price font-14-400">
              <span className="mr-l-10">هزینه ارسال: </span>
              {basketData?.delivery != 0
                ? `${addCommas(basketData?.delivery)} تومان`
                : "رایگان"}
            </div>
          )}

          <div className="price ">
            {/*<span>قیمت کل:</span> {addCommas(activeStep == 2 ? basketData?.totalPrice + basketData?.delivery : basketData?.totalPrice )} تومان*/}
            <span>قیمت کل:</span>
            <div>
              {/*<span className="font-14-600">{addCommas(basketData?.delivery)}</span>*/}
              <span className="font-14-400">
                {addCommas(basketData?.totalPrice)} تومان
              </span>
            </div>
          </div>
          {basketData?.totalDiscount != 0 && (
            <div className="price color-rd-01">
              <span className="text-black">تخفیف: </span>{" "}
              {addCommas(
                giftCode.value != -1
                  ? basketData?.totalDiscount + removeCommas(giftCode?.value)
                  : basketData?.totalDiscount
              )}{" "}
              تومان
            </div>
          )}
          <div className="price">
            <span>مبلغ پرداختی: </span>
            {/*{giftCode.value != -1 ? (*/}
            {/*    <div className="d-flex">*/}
            {/*        <span*/}
            {/*            className="pd-x-4">{addCommas((+basketData?.totalPrice + basketData?.delivery) - +basketData?.totalDiscount - giftCode?.value)}</span>{"  "}*/}
            {/*        <span className="text-decoration-line-through">*/}
            {/*            {addCommas(activeStep == 2 ? (+basketData?.totalPrice + basketData?.delivery) - +basketData?.totalDiscount : +basketData?.totalPrice - +basketData?.totalDiscount)} تومان*/}
            {/*        </span>*/}
            {/*    </div>*/}
            {/*) : (*/}
            <div className="price">
              {addCommas(
                activeStep == 2
                  ? +basketData?.totalPrice +
                      basketData?.delivery -
                      (+basketData?.totalDiscount +
                        (giftCode.value != -1
                          ? removeCommas(giftCode.value)
                          : 0))
                  : +basketData?.totalPrice - +basketData?.totalDiscount
              )}{" "}
              تومان
            </div>
            {/*)}*/}
          </div>
        </div>
        <div className="d-flex flex-row flex-sm-column col-9 col-sm-3 justify-content-evenly align-self-center mt-3 mt-sm-0">
          {activeStep === 2 ? (
            <Button
              variant="primary"
              className="mb-sm-1"
              onClick={(e) => setActiveStep(1)}
            >
              بازگشت
            </Button>
          ) : (
            ""
          )}
          {activeStep === 1 && (
            <Button
              variant="primary"
              onClick={(e) => setActiveStep(2)}
              disabled={itemCount == 0 ? true : false}
            >
              ثبت نهایی
            </Button>
          )}
          {activeStep === 2 && (
            <Button
              variant="primary"
              type="submit"
              form="shopping-list-form"
              onClick={(e) => setActiveStep(2)}
              className="position-relative"
              style={{ height: 40 }}
            >
              {btnLoading ? <WaveLoading color="white" /> : "پرداخت"}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Footer;
